import { useStateWithSearchParams } from "../../../hooks";
import { Order } from "../../../types";
import { DataSourceHeaderCell } from "./DataSourceHeaderCell";
import { TextCell } from "./TextCell";
import { SortCell } from "./SortCell";
import { RowWrapper } from "./RowWrapper";
import { useAppSelector } from "../../../hooks";

type SearchParams = {
  sort: undefined | string;
};

export const TableHeader = () => {
  const { isEditor } = useAppSelector((state) => state.company.userRoles);
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      sort: undefined,
    },
  );

  const sortHandler = (sort: string) => {
    if (!searchDict?.sort) {
      setSearchValue("sort", `${sort}-${Order.DESC}`);
      return;
    }

    const [currentSort, order] = searchDict?.sort.split("-");

    if (currentSort === sort) {
      setSearchValue(
        "sort",
        `${currentSort}-${order === Order.ASC ? Order.DESC : Order.ASC}`,
      );
    } else {
      setSearchValue("sort", `${sort}-${Order.DESC}`);
    }
  };

  const [sort, order] = searchDict.sort?.split("-") || [undefined, undefined];

  return (
    <RowWrapper>
      <DataSourceHeaderCell
        id={"full_name"}
        value="Name"
        order={order}
        maxWidth={"16%"}
        minWidth={"120px"}
        isSelected={sort === "full_name"}
        clickHandler={sortHandler}
        justifyContent="space-between"
      />
      <TextCell
        isHighlighted={true}
        value="Job title"
        maxWidth={"18%"}
        minWidth={"100px"}
      />
      <SortCell
        id={"seniority"}
        value="Seniority"
        order={order}
        maxWidth={"18%"}
        minWidth={"128px"}
        isSelected={sort === "seniority"}
        clickHandler={sortHandler}
        justifyContent="flex-start"
      />
      <SortCell
        id={"role"}
        value="Role"
        order={order}
        maxWidth={"14%"}
        minWidth={"124px"}
        isSelected={sort === "role"}
        clickHandler={sortHandler}
        justifyContent="flex-start"
        tooltip="Probable role of the contact in a buying committee."
      />
      <SortCell
        id={"engagement_score"}
        value="Engagement"
        order={order}
        maxWidth={"12%"}
        minWidth={"162px"}
        isSelected={sort === "engagement_score"}
        clickHandler={sortHandler}
        tooltip="Average engagement rate of all identified BC members within the account. Engagement rate refers
         to how active and efficient the communication with identified BC members is, based on phone calls, emails,
          meetings, and communication recency data."
      />
      <SortCell
        id={"committee_probability"}
        value="Committee"
        order={order}
        maxWidth={"12%"}
        minWidth={"148px"}
        isSelected={sort === "committee_probability"}
        clickHandler={sortHandler}
        tooltip="Probability rate of the contact being involved in the buying committee."
      />
      <SortCell
        id={"cluster_probability"}
        value="Cluster"
        order={order}
        maxWidth={"10%"}
        minWidth={"124px"}
        isSelected={sort === "cluster_probability"}
        clickHandler={sortHandler}
        tooltip="Probability rate of the contact being involved in the buying cluster - a narrow group of final
         decision makers inside the buying committee."
      />
      {isEditor && <div style={{ width: "48px", minWidth: "48px" }} />}
    </RowWrapper>
  );
};
